import React, { useEffect, useState } from "react";
import { useSettings } from '../SettingsContext';

const OurSuccess = () => {
    const settingFromContext = useSettings();
    const [setting, setSetting] = useState(null);

    useEffect(() => {
        // লোকালস্টোর থেকে আগে চেক করো
        const cachedSetting = localStorage.getItem('ourSuccessSetting');
        const cacheTimestamp = localStorage.getItem('ourSuccessSettingTimestamp');
        const now = Date.now();
        const THIRTY_MINUTES = 30 * 60 * 1000;

        if (cachedSetting && cacheTimestamp && (now - parseInt(cacheTimestamp) < THIRTY_MINUTES)) {
            setSetting(JSON.parse(cachedSetting));
        } else {
            setSetting(settingFromContext);
            localStorage.setItem('ourSuccessSetting', JSON.stringify(settingFromContext));
            localStorage.setItem('ourSuccessSettingTimestamp', now.toString());
        }
    }, [settingFromContext]);

    if (!setting) return null; // লোডিং/নাল চেক

    return (
        <div className="counter-area">
            <div className="counter-wrap">
                <div className="shape">
                    <img src="assets/img/shape/03.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/visa.svg" alt=""/>
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to="6560" data-speed="3000">{setting?.working_type}</span>
                                    <h6 className="title">+ Working Type</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/visa.svg" alt=""/>
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to="6560" data-speed="3000">{setting?.visa_consulting}</span>
                                    <h6 className="title">+ Visa Consulting</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box mt-lg-5">
                                <div className="icon">
                                    <img src="assets/img/icon/happy.svg" alt=""/>
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to="7320" data-speed="3000">{setting?.happy_client}</span>
                                    <h6 className="title">+ Happy Clients</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box mt-lg-5">
                                <div className="icon">
                                    <img src="assets/img/icon/award.svg" alt=""/>
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to="50" data-speed="3000">{setting?.win_awards}</span>
                                    <h6 className="title">+ Win Awards</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OurSuccess;
